<template>
    <TemplateTable
            :title="$t('menu.vouchers')"
            :text="$t('vouchers.description')"
            name="vouchers"
            :url="$listRoutes.vouchers"
            :table="vouchers"
            :filters="vouchersFilters"
            :fields="fields"
    />
</template>

<script>
import { mapState } from 'vuex';
import TemplateTable from '@/components/templates/TemplateTable';
export default {
    name: 'VouchersPage',
    components: {TemplateTable},
    data() {
        return {
            fields: [
                {key: 'id', type: 'eye', route: 'voucher', size: 'xs'},
                {key: 'client', type: 'client', size: 'l'},
                {key: 'user', type: 'userEmail', size: 'xl'},
                {key: 'amount', type: 'formatPrice'},
                {key: 'code', type: 'editVoucher', size: 'xl'},
                {key: 'shopDiscountId', type: 'copy', size: 'xl'},
                {key: 'createdAt', type: 'date'},
                {key: 'expiresOn', type: 'date'},
                //{key: 'source', type: 'tagType'},
                {key: 'type', type: 'voucherType', size: 'm'},
                {key: 'status', type: 'tagType', size: 'm'},
                {key: 'isBurn', type: 'boolean'},
                {key: 'burnedAt', type: 'date'},
                {key: 'country'},
            ]
        }
    },
    computed: {
        ...mapState(['vouchers', 'vouchersFilters'])
    }
}
</script>